<template>
  <div class="row animated fadeIn step-container">
    <div class="col-md-8 offset-md-2 step-body clinic-service-wrapper">
      <h4 class="step-header">
        <div class='title'>{{$t('message.services.title')}}</div>
        <button v-if="!showAddPanel" @click.prevent="showAddPanel = !showAddPanel; editMode = false; clearFormError();"class="add-service btn btn-success">+ {{$t('action_message.add')}}</button>
        <button v-if="showAddPanel" @click.prevent="showAddPanel = !showAddPanel; service = Object.assign({}, defaultService); clearFormError()"class="add-service btn btn-info">{{$t('action_message.list')}}</button>
      </h4>

        <div class='service-wrapper' v-if="!showAddPanel">
          <div v-if="!!services.length > 0" >
            <draggable v-model="services" @end="onServiceDraggableEnd">
              <transition-group>
                <div class="service-container" v-for="(s, index) in services" :key="index">
                  <div class='service-content' @click="editService(s)">
                    <h6>{{ s.th.name }}</h6> 
                    <div>{{ s.th.description }}</div>
                    <div v-if="s.is_price_range">
                      <strong>{{$t('message.services.price')}}</strong> {{ s.price_from }} - {{ s.price_to }}
                    </div>
                    <div v-if="s.is_price_from">
                      <strong>ราคาเริ่มต้น </strong> {{ s.price_from }}
                    </div>
                    <div v-if="!s.is_price_range && !s.is_price_from">
                      <strong>{{$t('message.services.price')}}</strong> {{ s.price }}
                    </div>
                    
                  </div>
                  <div class='service-actions'>
                    <i class="fa fa-pencil-square-o" @click="editService(s)"></i>
                    <div v-if="!$ismobile()">
                      <small>{{$t('action_message.edit')}}</small>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
          <h6 class="alert alert-warning" v-else>
            {{$t('message.services.no_services')}}
          </h6>
        </div>

        <div v-if="showAddPanel" class='service-form'>
          <h6>{{$t('message.services.add_new_service')}}</h6>
          <div>
            <bs-input class="remove-padding-bottom" :label="$t('message.services.service_name_th')" v-model="service.th.name" :placeholder="$t('message.services.service_name_th')"></bs-input>
            <error-box :message="frmError['th.name']"/>
            <div class="add-padding-bottom" />
          </div>
          <div>
            <bs-input class="remove-padding-bottom" :label="$t('message.services.service_name_en')" v-model="service.en.name" :placeholder="$t('message.services.service_name_en')"></bs-input>
            <error-box :message="frmError['en.name']"/>
            <div class="add-padding-bottom" />
          </div>

          <div class="form-divider"></div>

          <h6>{{$t('message.services.select_duration')}}</h6>
          <div>
            <bs-input class="remove-padding-bottom input-min" type="Number" min="1" max="59" v-model="service.duration" :placeholder="$t('message.services.service_duration')">
              <span slot="after" class="input-group-addon">
                <strong>{{$t('message.services.minutes')}}</strong>
              </span>
            </bs-input>
            <error-box :message="frmError.duration"/>
            <div class="add-padding-bottom" />
          </div>

          <div class="form-divider"></div>

          <h6>{{$t('message.services.price')}}  
            <div style="margin-left: 30px;" class="form-check form-check-inline"><input type="radio" name="basicInlineRadios" class="form-check-input" value="price_default" v-model="priceOption"><label class="form-check-label"><span>ปรกติ</span></label></div>
            <div class="form-check form-check-inline"><input type="radio" name="basicInlineRadios" class="form-check-input" value="price_range" v-model="priceOption"><label class="form-check-label"><span>{{$t('message.services.price_range')}}</span></label></div>
            <div class="form-check form-check-inline"><input type="radio" name="basicInlineRadios" class="form-check-input" value="price_from" v-model="priceOption"><label class="form-check-label"><span>ราคาเริ่มต้น</span></label></div>
          </h6>
          <div v-if="!service.is_price_range && !service.is_price_from">
            <bs-input class="remove-padding-bottom input-price-range" v-model="service.price" :placeholder="$t('message.services.price')">
              <span slot="after" class="input-group-addon">
                <strong>{{$t('message.services.baht')}}</strong>
              </span>
            </bs-input>
            <error-box :message="frmError.price"/>
            <div class="add-padding-bottom" />
          </div>
          <div v-if="service.is_price_range">
            <bs-input class="remove-padding-bottom input-price-range" v-model="service.price_from" :placeholder="$t('message.services.price_from')">
              <span slot="after" class="input-group-addon">
                <strong>{{$t('message.services.baht')}} ({{$t('message.services.price_from')}})</strong>
              </span>
            </bs-input>
            <bs-input class="remove-padding-bottom input-price-range" v-model="service.price_to" :placeholder="$t('message.services.price_to')">
              <span slot="after" class="input-group-addon">
                <strong>{{$t('message.services.baht')}} ({{$t('message.services.price_to')}})</strong>
              </span>
            </bs-input>
            <error-box :message="frmError.price_from"/>
            <error-box :message="frmError.price_10"/>
            <div class="add-padding-bottom" />
          </div>
          <div v-if="service.is_price_from">
            <bs-input class="remove-padding-bottom input-price-range" v-model="service.price_from" :placeholder="$t('message.services.price_from')">
              <span slot="after" class="input-group-addon">
                <strong>{{$t('message.services.baht')}} ({{$t('message.services.price_from')}})</strong>
              </span>
            </bs-input>
            <error-box :message="frmError.price_from"/>
            <error-box :message="frmError.price_10"/>
            <div class="add-padding-bottom" />
          </div>

          <div class="form-divider"></div>

          <h6>{{$t('message.services.service_detail')}}</h6>
          <bs-input type="textarea" :label="$t('message.services.service_detail_th')" v-model="service.th.description" :placeholder="$t('message.services.service_detail_th')"></bs-input>
          <bs-input type="textarea" :label="$t('message.services.service_detail_en')" v-model="service.en.description" :placeholder="$t('message.services.service_detail_en')"></bs-input>

          <div class="row">
            <div class="col-12 form-group">
              <button class="btn btn-lg btn-close" @click="cancelAddingService">{{$t('action_message.cancel')}}</button>
              <button class="btn btn-add btn-lg btn-success" @click="addService">{{ editMode ? $t('action_message.edit'): $t('action_message.add') }}</button>
              <button v-if="editMode" class="btn btn-add btn-lg btn-danger remove-service-action" @click="removeService">{{$t('action_message.remove')}}</button>
            </div>
          </div>
        </div>

        <div class="row" v-if="!showAddPanel">
          <div class="col-12 form-group">
            <button class="btn btn-cancel btn-lg" @click="cancelChange">{{$t('action_message.back')}}</button>
            <button class="btn btn-store btn-lg" @click="saveAndContinue">{{$t('action_message.save')}}</button>
            <slot name='loader'></slot>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { input as BsInput } from 'vue-strap'
import ErrorBox from '@/components/ErrorMessageBox'
import Draggable from 'vuedraggable'

export default {
  props: {
    clinic: {
      type: Object,
      default: {}
    }
  },
  components: {
    BsInput,
    ErrorBox,
    Draggable
  },
  data () {
    let defaultService = {
      th: {},
      en: {},
      price: null,
      duration: null
    }

    let formDefaultError = {
      'th.name': this.$t('message.services.service_name_require'),
      'en.name': this.$t('message.services.service_name_require'),
      duration: this.$t('message.services.service_duration_require'),
      price: this.$t('message.services.service_price_require')
    }

    let formCleanError = {
      'th.name': null,
      'en.name': null,
      duration: null,
      price: null
    }

    return {
      isModifiedOrder: false,
      services: [],
      defaultService,
      formDefaultError,
      formCleanError,
      frmError: Object.assign({}, formCleanError),
      service: Object.assign({}, defaultService),
      showAddPanel: false, // list mode
      editMode: false, // create mode
      priceOption: 'price_default'
    }
  },
  watch: {
    priceOption (newOption, oldOption) {
      if (newOption === 'price_default') {
        this.service.is_price_range = 0
        this.service.is_price_from = 0
      } else if (newOption === 'price_range') {
        this.service.is_price_range = 1
        this.service.is_price_from = 0
      } else if (newOption === 'price_from') {
        this.service.is_price_range = 0
        this.service.is_price_from = 1
      }
    }
  },
  methods: {
    saveAndContinue () {
      if (this.isModifiedOrder) {
        this.services.forEach(service => this._updateServiceWithOrder(service))
      }

      // work with sync modifier
      this.$emit('update:clinic', this.clinic)

      // finish step with changed data
      this.$emit('finishStep')
    },
    cancelChange () {
      this.$emit('cancelChange')
    },
    editService (service) {
      this.service = service
      this.showAddPanel = true
      this.editMode = true

      if (!this.service.is_price_range && !this.service.is_price_from) {
        this.priceOption = 'price_default'
      } else if (this.service.is_price_range) {
        this.priceOption = 'price_range'
      } else if (this.service.is_price_from) {
        this.priceOption = 'price_from'
      }
    },
    cancelAddingService () {
      this.service = this.defaultService
      this.showAddPanel = false
    },
    async removeService (s) {
      if (await this.$confirm(this.$t('action_message.are_you_sure'))) {
        this.$http.delete(this.$APP_CONFIG.api.admin.clinicme_services_id(this.service.id, this.$route, this.$guser),
          {
            credentials: true,
            headers: { 'content-type': 'application/json' }
          }).then(res => {
            // save success
            this.service = this.defaultService
            // go to list panel
            this.showAddPanel = false
            // append service
            this.refreshService()
          })
      }
    },
    addService () {
      if (this.editMode) {
        this._updateService()
      } else {
        this.clearFormError()
        this.$http.post(this.$APP_CONFIG.api.admin.clinicme_services(this.$route, this.$guser),
          // data
          this.service,
          // options
          {
            credentials: true,
            headers: { 'content-type': 'application/json' }
          }).then(res => {
            if (res.body.id) {
              // save success
              this.service = this.defaultService
              // go to list panel
              this.showAddPanel = false
              // append service
              this.refreshService()
            }
          },
          error => {
            if (error.body.error) {
              this.showFormFromError(error.body.error)
            }
          })
      }
    },
    _updateService () {
      // remove unnecsessary fields
      delete this.service.updated_at
      delete this.service.created_at
      delete this.service.order
      delete this.service.d_price
      delete this.service.clinic_id

      this.clearFormError()

      this.$http.put(this.$APP_CONFIG.api.admin.clinic_services_id(this.service.id),
        // data
        this.service,
        // options
        {
          credentials: true,
          headers: { 'content-type': 'application/json' }
        }).then(res => {
          if (res.body.id) {
            // save success
            this.service = this.defaultService
            // go to list panel
            this.showAddPanel = false
            // append service
            this.refreshService()
          }
        },
        error => {
          if (error.body.error) {
            this.showFormFromError(error.body.error)
          }
        })
    },
    _updateServiceWithOrder (service) {
      // remove unnecsessary fields
      delete service.updated_at
      delete service.created_at
      delete service.clinic_id
      this.$http.put(this.$APP_CONFIG.api.admin.clinic_services_id(service.id),
        // data
        service,
        // options
        {
          credentials: true,
          headers: { 'content-type': 'application/json' }
        }).then(res => {})
    },
    refreshService () {
      var self = this

      let reqUrl = this.$APP_CONFIG.api.admin.clinicme_services()
      if (this.$route.query.ref_clinic_id) {
        reqUrl = `${this.$APP_CONFIG.api.admin.domain()}/clinics/${this.$route.query.ref_clinic_id}/services`
      }

      // fetch clinic services
      this.$http.get(reqUrl, { credentials: true }).then(res => {
        /*
        {
            "status": "success",
              "data": []
        }
        */
        if (res.body.data) {
          self.services = res.body.data.sort((obj1, obj2) => {
            return obj1.order - obj2.order
          })
        }
      }, errorResponse => {
        console.error(errorResponse)
      })
    },
    clearFormError () {
      this.frmError = Object.assign({}, this.formCleanError)
    },
    showFormFromError (error) {
      if (error) {
        this.frmError['th.name'] = this.getMessageFromError(error['th.name'])
        this.frmError['en.name'] = this.getMessageFromError(error['en.name'])
        this.frmError.duration = this.getMessageFromError(error.duration)
        this.frmError.price = this.getMessageFromError(error.price)
      }
    },
    getMessageFromError (errorObj) {
      let _message = null
      if (errorObj && Array.isArray(errorObj)) {
        _message = errorObj.join(' ')
      } else {
        _message = errorObj
      }
      return _message
    },
    onServiceDraggableEnd (evt) {
      this.isModifiedOrder = true
      for (var index in this.services) {
        this.services[index].order = (+index)
      }
    }
  },
  created () {
    this.refreshService()
  }
}
</script>

<style lang='scss'>
@import "../../../assets/base_container";

.input-min {
  width: 200px;
}
.input-price-range {
  width: 300px;
}

.service-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #fafafa;
  border: 1px solid #ddd;
  margin-bottom: 0.5em;
  border-radius: 5px;
  
  h6 {
    margin: 0;
  }
  
  .service-content {
    flex: 2; 
    padding: 0.5rem;
    border-right: 1px solid #ddd;
  }

  .service-actions {
    padding: 1em;
    text-align: center;
  }
}

.remove-service-action {
  float: right;
}

.clinic-service-wrapper {
  .step-header {
    display: flex;
    justify-content: center;
    align-items: center;

    .title {
        flex: 1;
    }
  }
  .form-check-inline {
    margin-right: 20px !important;
  }
  .form-check-inline .form-check-label {
    font-size: 16px;
    font-weight: normal;
    padding-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// Services.vue?ab822e3a